import React from "react";

const ChevronDown = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="10.525" height="6.277" viewBox="0 0 10.525 6.277">
			<path
				id="icon-chevron"
				d="M5.262,3.861,1.692.29a.991.991,0,0,0-1.4,0h0a.991.991,0,0,0,0,1.4L4.6,6A.933.933,0,0,0,5.923,6l4.311-4.311a.991.991,0,0,0,0-1.4h0a.991.991,0,0,0-1.4,0Z"
				fill="#fff"
			/>
		</svg>
	);
};

export default ChevronDown;
